import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BriefingService, UserService } from '../services';
import * as _ from 'lodash';

@Component({
    template: `
        <div fxLayout="column">
            <div fxLayout="column" fxLayoutAlign="center center"><spinner style="padding-top: 30px;"></spinner></div>
        </div>
    `
})
export class BriefingSubscribeComponent implements OnInit {
    noTouching: boolean = true;
    briefing: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                public snackBar: MatSnackBar,
                private briefingService: BriefingService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.noTouching = true; 
        this.briefingService.getUnauthBriefings({}).pipe(first())
        .subscribe(briefingsResponse => {
            const user = this.userService.getCurrentUser();
            this.briefing = _.find(briefingsResponse.content, {id: this.route.snapshot.params.briefingId });
            if(user && this.route.snapshot.params.briefingId && this.briefing){
                this.userService.subscribeToBriefing(user, this.briefing.id, this.briefing.streamId).pipe(first())
                .subscribe(() => {
                    this.router.navigate(['briefings']);
                    this.snackBar.open(`Subscribed to: ${this.briefing.briefingTitle}`, 'OK', { duration: 3000});
                });
            } else {
                this.router.navigate(['briefings']);
                this.snackBar.open(`Unable to subscribe to unkown briefing.`, 'OK', { duration: 3000});
            }
        });    
    }
}